'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _reseller = require('../actions/reseller');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  items: [],
  pagination: {}
};
var resellers = function resellers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _reseller.RECEIVE_RESELLERS:
      return _extends({}, state, {
        items: action.data,
        pagination: action.pagination
      });
    case _reseller.FAILURE_RESELLERS:
      return _extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

var INITIAL_WITHDRAW = {
  items: [],
  pagination: {}
};
var withdraws = function withdraws() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_WITHDRAW;
  var action = arguments[1];

  switch (action.type) {
    case _reseller.RECEIVE_WITHDRAWS:
      return _extends({}, state, {
        items: action.data,
        pagination: action.pagination
      });
    case _reseller.FAILURE_WITHDRAWS:
      return _extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

var resellerReducer = (0, _redux.combineReducers)({
  resellers: resellers,
  withdraws: withdraws
});

exports.default = resellerReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/resellers.js
// module id = 915
// module chunks = 0